import { CustomersDashboardIconNotChosen, CustomersDashboardIcon, AccountNivIcon, AccountNivSelectedIcon, DiscoveryIcon, DiscoveryIconSelected, IdeasIcon, IdeasIconSelected, ImportNivIcon, ImportSelectedNivIcon, IntegrationsNivIcon, IntegrationsSelectedNivIcon, MembersNivIcon, MembersNivSelectedIcon, ObjectsFieldsNivIcon, ObjectsFieldsSelectedNivIcon, ProductAreaNivIcon, ProductAreaNivSelectedIcon, ReportsIcon, ReportsIconSelected, RequestsIcon, RequestsIconSelected, TeamsNivIcon, TeamsNivSelectedIcon, ApiSelectedNivIcon, ArchivedIconSelected, ArchiveIcon } from "../../icons/x-symbol-svgrepo-com";
import { IconFileExport, IconTag, IconApiApp, IconShield, IconBrain , IconBell } from "@tabler/icons";

export const showTopReports = window.__RUNTIME_CONFIG__.REACT_APP_SHOW_TOP_REPORT === "true";

export const mainLinks = [
  { link: "/discovery", label: "Discovery", icon: DiscoveryIcon, activeIcon: DiscoveryIconSelected, disabled: false },
  { link: "/inbox", label: "Inbox", icon: RequestsIcon, activeIcon: RequestsIconSelected, disabled: false },
  { 
    label: "Ideas", 
    icon: IdeasIcon, 
    activeIcon: IdeasIconSelected, 
    disabled: true,
    isMenuTrigger: true,
    style: { cursor: 'default' },
    children: [
      { link: "/ideas/all", label: "All", disabled: false }, 
      { link: "/ideas/archived", label: "Archived", disabled: false },
    ]
  },
  {
    link: "/trends",
    label: "Trends",
    icon: ReportsIcon,
    activeIcon: ReportsIconSelected,
    disabled: !showTopReports,
  },{
    link: "/customer360",
    label: "Customer 360",
    icon: CustomersDashboardIconNotChosen,
    activeIcon: CustomersDashboardIcon,
  },
];

export const settingsLinks = [
  { link: "/settings/account", label: "Account", icon: AccountNivIcon, activeIcon: AccountNivSelectedIcon },
  { link: "/settings/members", label: "Members", icon: MembersNivIcon, activeIcon: MembersNivSelectedIcon},
  { link: "/settings/teams", label: "Teams", icon: TeamsNivIcon, activeIcon: TeamsNivSelectedIcon },
  {
    link: "/settings/productareas",
    label: "Product area",
    icon: ProductAreaNivIcon, activeIcon: ProductAreaNivSelectedIcon
  },
  {
    link: "/settings/tags",
    label: "Tags",
    icon: IconTag, activeIcon: IconTag
  },
  { link: "/settings/filters", /* onlyBagel:true, */ label: "Filters & segments", icon: ObjectsFieldsNivIcon , activeIcon: ObjectsFieldsSelectedNivIcon},
  { link: "/settings/objects", label: "Objects & fields", icon: ObjectsFieldsNivIcon , activeIcon: ObjectsFieldsSelectedNivIcon},
  { link: "/settings/property", onlyBagel:true, label: "Property", icon: ObjectsFieldsNivIcon , activeIcon: ObjectsFieldsSelectedNivIcon},
  {
    link: "/settings/integrations2.0",
    label: "Integrations",
    icon: IntegrationsNivIcon, activeIcon: IntegrationsSelectedNivIcon
  },
  {
    link: "/settings/pii-redaction",
    label: "PII Redaction",
    icon: IconShield, activeIcon: IconShield
  },
  {
    link: "/settings/ml-settings",
    label: "ML Settings",
    icon: IconBrain, activeIcon: IconBrain
  },
  {
    link: "/settings/import",
    label: "Import",
    icon: ImportNivIcon, activeIcon: ImportSelectedNivIcon,
    children: [
      {
        link: "/settings/import/ideas_evidence",
        label: "Ideas and evidence",
      },
      {
        link: "/settings/import/items",
        label: "Potential evidence",
      },
    ],
  },
  {
    link: "/settings/export",
    label: "Export",
    icon: IconFileExport,
    activeIcon: IconFileExport,
    children: [
      {
        link: "/settings/export/ideas",
        label: "Ideas",
      },
      {
        link: "/settings/export/items",
        label: "Evidence",
      },
    ],
  },
  { link: "/settings/tokens", label: "API", icon: IconApiApp, activeIcon: ApiSelectedNivIcon },
  { link: "/settings/notifications", label: "Notifications", icon: IconBell, activeIcon: IconBell },
];
